// Features.jsx | características


// src/site/components/features.jsx
import React from "react";
import './features.css';

function Features() {
  const benefits = [
    {
      icon: "bi-whatsapp",
      title: "Seus clientes agendam com 1 clique",
      desc: "Eles recebem seu link personalizado no WhatsApp e marcam sem precisar baixar app ou se cadastrar."
    },
    {
      icon: "bi-bell",
      title: "Menos faltas, mais faturamento",
      desc: "Lembretes automáticos por WhatsApp reduzem cancelamentos em até 70%."
    },
    {
      icon: "bi-cloud",
      title: "Acesse de qualquer lugar",
      desc: "Celular, tablet ou PC — sua agenda sempre com você, 100% online."
    },
    {
      icon: "bi-link-45deg",
      title: "Nunca perca um cliente avulso",
      desc: "Agende mesmo quem não tem conta: basta enviar um link pelo WhatsApp."
    }
  ];

  return (
    <section id="features" className="py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Por que profissionais escolhem o Agendex?</h2>
          <p className="text-muted">Tudo pensado para você ganhar tempo, clientes e faturamento.</p>
        </div>
        <div className="row g-4">
          {benefits.map((b, i) => (
            <div key={i} className="col-md-6 col-lg-3">
              <div className="text-center p-4">
                <div className="icon-circle bg-primary text-white d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '60px', height: '60px' }}>
                  <i className={`bi ${b.icon} fs-3`}></i>
                </div>
                <h5>{b.title}</h5>
                <p className="text-muted">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Features;